export default "__VITE_ASSET__CPLdmd_b__"